<template>
  <div class="discussion-list-item-author" :key="'imgav'+refresher"
>
    <div v-if="email != ''">
    <img
      v-if="avatarurl"
      v-bind:src="avatarurl"
      v-bind:title="email"
      class="img-fluid rounded-circle z-depth-0 avatar"
      alt="avatar"
      width="30px"
      height="30px"
    />
    <span v-else class="avatar">{{ email.substring(0, 2) }}</span>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "AvatarFromProfileByEmail",
  props: {
    email: ""
  },
  data: function() {
    return {
      refresher: 0,
      avatarurl: ""
    };
  },
  created() {
    console.log('creatd with email: '+this.email);

    this.mthFillAvatafUrlFromProfile(this.email);
  },
  methods: {
    mthFillAvatafUrlFromProfile(email) {
      console.log("mthGetAvatafUrlFromProfile runs with ");
      console.log(email);

      var that = this;
      //console.log(email);

      if (email != "")
        var result = firebase
          .firestore()
          .collection("usersProfiles")
          .doc(email)
          .get()
          .then(doc => {
            console.log(doc.data().profilePersonalInfo.avatarUrl)
            console.log("returns ");
            console.log(doc.data().profilePersonalInfo.avatarUrl);
            that.avatarurl = doc.data().profilePersonalInfo.avatarUrl;
            that.refresher++;
            //that.$forceUpdate();
          });
      else
      {
        console.log('returning sync');

        this.avatarurl = "sync...";
      }

      //if (email != "") return email.substring(0, 2);
    }
  }
};
</script>

<style scoped>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
